import {setUserSession, setDictionaries} from "../storage/user";
import callSkyduck from "./utils";

const AUTHORIZED = true;
const ANONYMOUS = false;

export async function userIdAndToken(email, password) {
    let uri = '/api/1/signInFront';
    let body = {
        "email": email,
        "password": password
    };
    return callSkyduck(uri, ANONYMOUS, body)
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw Error("Invalid login or password");
            }
        }).then(json => {
            setUserSession(
                email,
                json.response.userData._id,
                json.response.userData.token,
                json.response.userData.name,
                json.response.userData.avatarURL,
            );
        });
}

export async function userIdAndTokenByFacebook(email, fbToken) {
    let uri = '/api/1/signInFacebookToken';
    let body = {
        "fbToken": fbToken
    };
    return callSkyduck(uri, ANONYMOUS, body)
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                if (response.json().errorCode === 3) {
                    throw Error("It seems, that your account is not linked with Facebook. Please enter using your E-mail.");
                } else {
                    throw Error("Unable to sign in with Facebook. Please try again later or enter using your E-mail.");
                }
            }
        }).then(json => {
            setUserSession(
                email,
                json.response.userData._id,
                json.response.userData.token,
                json.response.userData.name,
                json.response.userData.avatarURL,
            );
        });
}

export async function getJumps(progress, lastJumpNumber = 0, jumps = []) {
    let uri;
    if (lastJumpNumber) {
        uri = '/api/1/jumpsJSON?lastJumpNumber=' + lastJumpNumber;
    } else {
        uri = '/api/1/jumpsJSON';
    }

    // TEST ONLY (Igor)
    // let userId = '5ce0a468208abe00a03accf5';
    // let token = 'fe65b34afcd2d59df1006e813453f09c';
    // setUserSession('testuser', userId, token);

    // TEST ONLY (Vadim)
    // let userId = '5cca2fc4208abe001d4f9889';
    // let token = '1f233a09c9040f12441cd0cf089fccb5';
    // setUserSession('testuser', userId, token);

    return new Promise((resolve, reject) =>
        callSkyduck(uri, AUTHORIZED, null, {'LASTUPDATETIMESTAMP': 0}).then(response => {
            response.json().then(data => {
                jumps = jumps.concat(data.response.jumps);
                if (data.response.hasMore > 0) {
                    progress && progress(jumps);
                    let newLastJumpNumber = jumps[jumps.length - 1].jumpNumber;
                    getJumps(progress, newLastJumpNumber, jumps).then(resolve).catch(reject);
                } else {
                    resolve(jumps);
                }
            }).catch(reject);
        }).catch(reject));
}

export async function dictionaries() {
    let uri = '/api/1/dictionaries';
    return callSkyduck(uri, AUTHORIZED)
        .then(response => {
            if (response.ok) return response.json();
        }).then(json => {
            let canopies = json.response.conopies.map(canopy => {
                return {
                    value: canopy.name,
                    label: canopy.name
                }
            });
            let dropzones = json.response.dropzones.map(dropzone => {
                return {
                    value: dropzone._id,
                    label: dropzone.name
                }
            });
            let aircrafts = json.response.aircrafts.map(aircraft => {
                return {
                    value: aircraft.name,
                    label: aircraft.name
                }
            });
            let wingsuites = json.response.wingsuites.map(aircraft => {
                return {
                    value: aircraft.name,
                    label: aircraft.name
                }
            });

            setDictionaries({
                canopies: canopies,
                jumpIcons: json.response.jumpIcons,

                dropzones: dropzones,
                aircrafts: aircrafts,
                wingsuites: wingsuites
            })
        });
}

export async function uploadJumps(jumps, units, editing) {
    let uri = '/api/1/addJumpJSON';
    let body = {
        "jumps": jumps.map(jump => {
            let jumpToUpload =  {
                "dropzoneID": jump.dropzone,
                "date": jump.date,
                "title": jump.title,
                "jumpNumber": parseInt(jump.jumpNumber),
                "aircraft": jump.aircraft,
                "wingsuit": jump.wingsuit,
                "canopy": jump.canopy,
                "distanceFromTarget": parseFloat(jump.distanceFromTarget),
                "freeFallTime": parseFloat(jump.freeFallTime),
                "exitAltitude": parseFloat(jump.exitAltitude),
                "deployAltitude": parseFloat(jump.deployAltitude),
                "comment": jump.comment,
                "iconIDs": jump.iconIDs
            }

            if (editing) {
                jumpToUpload.jumpID = jump.jumpID;
            }

            return jumpToUpload;
        })
    }

    return callSkyduck(uri, AUTHORIZED, body)
        .then(response => {
            if (response.ok) return response.json();
        });
}

export async function deleteJump(jumpID) {
    let uri = '/api/1/deleteJumpJSON';
    let body = {
        "jumpID": jumpID
    }
    return callSkyduck(uri, AUTHORIZED, body)
        .then(response => {
            if (response.ok) return response.json();
        });
}

export async function printLogbook(units, date, page, printFormat, email) {
    let uri = '/api/1/printLogbook';
    let body = {
        "units": units,
        "date": date,
        "page": page,
        "printFormat": printFormat,
        "email": email
    }
    return callSkyduck(uri, AUTHORIZED, body)
        .then(response => {
            if (response.ok) return response.json();
        });
}

export default function getJump3DLink(jumpId, units) {
    return "https://skyduck.app/3d/" + jumpId + "?jsRandom=2&speed=ms&"
        + "elevation=" + (units === 'metric' ? "meters" : "ft")
        + "&distance=" + (units === 'metric' ? "meters" : "ft");
}